<template>
<modal title="Client Config">
  <div>
    <p>Add the following configuration to your .env file. 
      <span class="has-text-danger">The secret is only shown once.</span>
    </p>
    <env-keys :keys="config"/>

    <p class="mt-2">Then run the following </p>
    <p class="has-text-danger">php artisan snitch:scan</p>
  </div>
</modal>  
</template>
<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>